// bao migrate skip
import TabPage from "./../../factories/tab-page";
import Bao from "./../../services/bao-service";
import * as $ from "jquery";
import * as ko from "knockout";
import GenericListTab from "./../../factories/generic-list-tab";
import baoRouter from "./../../services/bao-router";
class ShiftbookTabUniversalField extends GenericListTab {
    constructor(tabPage: TabPage, parent) {
        super(tabPage, parent);
        this.SaveAllowed = parent.SaveAllowed;
        this.Models.subscribe(() => {
            this.Selection([]);
        });
    }
    PageSize = ko.observable(0);
    SaveAllowed: KnockoutObservable<boolean>;
    ControllerUrl = "ShiftbookTabUniversalField";
    CustomFilter(): Models.HashObject[] {
        return null;
    }
    ToggleToolbarButtons() {
        super.ToggleToolbarButtons();
        ko.utils.arrayForEach(this.ToolbarButtons(), (button: any) => {
            var key = ko.unwrap(button.ActionKey);
            if (key === "ShiftbookTabUniversalFieldMoveUp" || key === "ShiftbookTabUniversalFieldMoveDown") {
                button.Enabled(this.Selection() != null && this.Selection().length > 0);
            }
        });
    }
    CustomToolbarClick = (action: Interfaces.Bao.BaoMenuItem) => {
        var key = ko.unwrap(action.ActionKey);
        if (key === "ShiftbookTabUniversalFieldMoveUp") {
            this.moveShiftbookTabUniversalField("MoveUp");
        }
        else if (key === "ShiftbookTabUniversalFieldMoveDown") {
            this.moveShiftbookTabUniversalField("MoveDown");
        }
    };
    ItemCompleteCheck(): JQueryPromise<boolean> {
        var def = $.Deferred<boolean>();
        def.resolve(true);
        return def.promise();
    }
    public Edit(item) {
        if (item != null) {
            this.Dialog(ko.unwrap(item.PrimaryKeyValue));
        }
    }
    private moveShiftbookTabUniversalField = (action: string) => {
        this.TabPage.IsLoading(true);
        var selection = this.Selection();
        var guidList = [];
        ko.utils.arrayForEach(selection, function (item) {
            guidList.push(ko.unwrap(item.ShiftbookTabUniversalfieldId));
        });
        Bao.post("ShiftbookTabUniversalField/" + action + "ShiftbookTabUniversalField", JSON.stringify({
            sessionTabId: this.SessionTabId,
            id: guidList
        }))
            .then(_ => this.Get())
            .then(_ => this.TabPage.DirtyFlag(true));
    };
    link(index: number, model) {
        var linkHash = 'universalField/' + model.UniversalFieldId;
        baoRouter.setHash(linkHash);
    }
}
export default ShiftbookTabUniversalField;